import store from "@/store";

export function ConvertProductData(product_data) {
  let gtm_product = {
    item_id: product_data.GoodsID,
    item_name: product_data.Title,
    item_brand: GetCompanyName(),
    price: parseInt(GetLowPrice(product_data.Stock)),
    item_variant: GetVariant(product_data.Stock),
    item_list_id:
      product_data.Menu.length > 0 ? product_data.Menu[0].MenuID : "",
    index: product_data.Seq,
    currency: "TWD",
  };

  for (let i = 1; i <= 5; i++) {
    if (product_data.Menu.length >= i) {
      i == 1
        ? (gtm_product.item_category = product_data.Menu[i - 1].Title)
        : (gtm_product[`item_category${i}`] = product_data.Menu[i - 1].Title);
    }
  }
  return gtm_product;
}

export function ConvertAddShopCartData(product_data, active_options, amount) {
  const ColorTitle = product_data.stock.ColorTitle;
  const SizeTitle = product_data.stock.SizeTitle;
  const Price = product_data.stock.SellPrice;

  let gtm_product = {
    item_id: product_data.goodsID,
    item_name: product_data.Title,
    quantity: amount,
    item_brand: GetCompanyName(),
    price: parseInt(Price),
    item_variant: `${ColorTitle},${SizeTitle}`,
    // item_list_id:
    //   product_data.Menu.length > 0 ? product_data.Menu[0].MenuID : "",
    index: product_data.Seq,
    currency: "TWD",
  };

  // for (let i = 1; i <= 5; i++) {
  //   if (product_data.Menu.length >= i) {
  //     i == 1
  //       ? (gtm_product.item_category = product_data.Menu[i - 1].Title)
  //       : (gtm_product[`item_category${i}`] = product_data.Menu[i - 1].Title);
  //   }
  // }
  return gtm_product;
}

export function GetCompanyName() {
  const column = store.state.common_column_data.filter(
    (column) => column.Title == "company_name"
  );
  return column.length <= 0 ? "" : column[0].Content;
}

export function GetLowPrice(stocks) {
  let price = 9999;
  stocks.forEach((item) => {
    parseInt(item.SellPrice) < price ? (price = item.SellPrice) : "";
  });
  return price == 9999 ? 0 : price;
}

export function GetVariant(stocks) {
  return stocks.length > 0
    ? `${stocks[0].ColorTitle},${stocks[0].SizeTitle}`
    : "";
}

export function GTM_AddPaymentInfo(shopcart, payment_title) {
  let products = [];

  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item,
      item.active_option,
      item.amount
    );
    products.push(product);
  });

  window.dataLayer.push({
    event: "addPaymentInfo",
    items: products,
    value: 0,
    currency: "TWD",
    payment_type: payment_title,
  });
}

export function GTM_AddShipInfo(shopcart, shipping_title, ship_price) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item,
      item.active_option,
      item.amount
    );
    products.push(product);
  });

  window.dataLayer.push({
    event: "addShippingInfo",
    items: products,
    value: 0,
    currency: "TWD",
    shipping: ship_price,
    shipping_tier: shipping_title,
  });
}

export function GTM_BeginCheckout(shopcart) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(item, item.active_option, 1);
    products.push(product);
  });
  window.dataLayer.push({
    event: "beginCheckout",
    items: products,
    value: 0,
    currency: "TWD",
  });
}

export function GTM_Purchase(shopcart, trade_data, coupon_info, form_data) {
  let products = [];

  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item,
      item.active_option,
      item.amount
    );
    products.push(product);
  });

  window.dataLayer.push({
    event: "purchase",
    trade_no: trade_data.TradeID,
    items: products,
    value: trade_data.Price,
    currency: "TWD",
    tax: 0,
    shipping: trade_data.ShippingFee,
    coupon: coupon_info,
    email: form_data.consignee_email,
    phone: form_data.buyer_phone,
    first_name: form_data.buyer_first_name,
    last_name: form_data.buyer_last_name,
    address: form_data.consignee_address,
    city: form_data.consignee_city,
    area: form_data.consignee_area,
    country: "台灣",
    zip_code: form_data.zip_code,
  });
}

export function GTM_AddShopCart(shopcart_item, amount) {
  window.dataLayer.push({
    event: "add_to_cart",
    items: [
      ConvertAddShopCartData(
        shopcart_item,
        shopcart_item.active_option,
        amount
      ),
    ],
    value: 0,
    currency: "TWD",
  });
}

export function GTM_RemoveShopCart(shopcart_item, amount) {
  window.dataLayer.push({
    event: "remove_from_cart",
    items: [
      ConvertAddShopCartData(
        shopcart_item,
        shopcart_item.active_option,
        amount
      ),
    ],
    value: 0,
    currency: "TWD",
  });
}

export function GTM_OpenShopCart(shopcart) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(item, item.active_option, 1);
    products.push(product);
  });
  window.dataLayer.push({
    event: "view_cart",
    items: products,
    value: 0,
    currency: "TWD",
  });
}

export function GTM_ViewProduct(product_data) {
  window.dataLayer.push({
    event: "viewProduct",
    items: [ConvertProductData(product_data)],
    value: 0,
    currency: "TWD",
  });
}

export function GTM_ViewItemList(category_title, category_id) {
  window.dataLayer.push({
    event: "viewItemList",
    item_list_name: category_title,
    item_list_id: category_id,
    value: 0,
    currency: "TWD",
  });
}

export function GTM_CustomEvent(event_name) {
  window.dataLayer.push({
    event: event_name,
  });
}

export function GTM_TestPurchase() {
  const data = {
    address: "台中市西區居仁街15號3樓之4",
    area: "頭城鎮",
    city: "宜蘭縣",
    country: "台灣",
    coupon: "",
    currency: "TWD",
    email: "piggy5272@gmail.com",
    event: "purchase",
    first_name: "測試",
    items: [
      {
        currency: "TWD",
        index: "4",
        item_bran: "耀聞水果世界",
        item_category: "店長推薦",
        item_category2: "麝香葡萄（シャインマスカット）",
        item_id: "61",
        item_list_id: "7",
        item_name: "岡山『 晴王』麝香葡萄",
        item_variant: "一托 350公克,一托350公克 (不含禮盒）",
        price: 990,
        quantity: 1,
      },
    ],
    last_name: "泳欣",
    phone: "0980562682",
    shipping: "0",
    tax: 0,
    trade_no: "test_" + (Math.floor(Math.random(100) * 100) + 101),
    value: 990,
    zip_code: "261",
  };
  window.dataLayer.push(data);
}
